import React from "react";
import "../../../../App.css";
import { Form } from "react-bootstrap";

class Authentication extends React.Component {
  // constructor(){
  //     super()
  // }
  render() {
    return (
      <div>
        <div className="vertical-center outer">
          <div></div>
          <div>
            <div align="center">
              <h3>
                <b>Enter your authentication code</b>
              </h3>
              <p>
                <b>
                  We just sent you a temporary code to validate
                  <br />
                  your email address, check your inbox.
                </b>
              </p>
            </div>
            <Form style={{ marginTop: "10%" }} align="center">
              <Form.Group controlId="formGroupEmail">
                <Form.Control
                  type="email"
                  style={{ border: "1px solid black", height: "4vh" }}
                  name="code"
                  placeholder="Authentication code"
                />
              </Form.Group>
            </Form>
            <div style={{ marginTop: "20%" }} align="center">
              <div align="left">
                <p>
                  <u>
                    didn,t receive code?<b>Resend</b>
                  </u>
                </p>
              </div>
              <div
                align="center"
                style={{ height: "4vh" }}
                className="signIn-button vertical-center"
              >
                <span>
                  <b>Sign in</b>
                </span>
              </div>
            </div>
          </div>
          <div></div>
        </div>
      </div>
    );
  }
}

export default Authentication;
